<template>
  <a
    :href="href"
    target="_blank"
    class="preview-link"
    aria-label="Expand"
    title="Preview document (in new tab)"
    v-b-tooltip.hover="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }"
  >
    <span class="material-symbols-outlined open-in-new-tab-icon">
      open_in_new
    </span>
  </a>
</template>

<script>
export default {
  name: 'PreviewButton',
  props: {
    href: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
.preview-link {
  display: inline-block;
  height: 20px;
  padding: 2px 0;
}

.open-in-new-tab-icon {
  font-size: 18px;
  color: $body-color;
  font-weight: 600;
}
</style>
